import { createFileRoute } from '@tanstack/react-router'

import { ProfilePanel } from '@/features/user/profile'

export const Route = createFileRoute('/_event/minha-conta/perfil')({
  component: ProfilePanel
})
